

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import UserApi from "../../../../services/UserApi.jsx";
import { separatorNumber, useGlobalFunc } from "../../../../global/constants.js";
import { Pagination } from "@mui/material";






// import homeshadowImg from '../../../assets/homeshadow.png'
// import homescrollImg from '../../../assets/homescroll.png'

// import homepic1Img from '../../../assets/homepic1.png'
// import homepic2Img from '../../../assets/homepic2.png'


const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);


    const { setLoading, successToast, errorToast } = useGlobalFunc()
    const [totalPage, setTotalPage] = useState(1);
    const [page, setPage] = useState(1);
    const handleChange = (event, value) => {
        setPage(value);
        getDataList(value)
    };

    const [dataList, setDataList] = useState(null)

    async function getDataList(page) {
        setLoading(true)
        try {
            let res = await UserApi.negotiationSearch({ page: page })
            console.log(res.data.data)
            setDataList(res.data.data)
            setTotalPage(res.data.total == 0 ? 1 : Math.ceil(res.data.total / 10))

        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)

    }

    useEffect(() => {
        getDataList(1)
    }, []);

    return <div className="mt-8 text-black96  relative  w-full px-4 sm:px-10 py-5 sm:py-7 bg-white border-solid border border-black06 rounded-[20px]">
        <div className="flex justify-between items-center mb-6 w-full">
            <div className="text-lg font-bold ">{t('memberCenterType.negotiation')}</div>
            <button onClick={() => navigate('/membercenter/negotiationcreate')} className="btn1 !bg-red1 !rounded-md">新增協談</button>
        </div>
        <div className="   whitespace-nowrap w-full  overflow-x-auto pb-10">
            <table className="w-full text-sm" >
                <thead className="">

                    <tr className="  text-black96 bg-black02 text-xs font-semibold ">
                        <th className="">被協談者名稱</th>
                        <th className="">送單日期</th>
                        <th className="">派送日期</th>
                        <th className="">完成日期</th>
                        <th className="">協談進度</th>
                        <th className=""></th>
                    </tr>
                </thead>

                <tbody>
                    {
                        dataList && dataList.map(i => <tr key={i.id} className="align-top text-black9 font-semibold ">
                            <td className="">{i.name}</td>
                            <td className="">{i.createdAt}</td>
                            <td className="">{i.dispatchDate}</td>
                            <td className="">{i.endDate}</td>
                            <td className="">{t(`negotationStatus.${i.status}`)}</td>
                            <td className="">
                                <button onClick={() => navigate(`${i.id}`)} className="text-red1 font-bold rounded-md bg-white px-2 py-1 border-solid border border-red1">
                                    詳細
                                </button>
                            </td>
                        </tr>
                        )
                    }

                </tbody>
            </table>



        </div>
        {
            dataList != null ?
                <>
                    {
                        dataList.length == 0 ?
                            <div className="  text-center text-gray-400 text-lg w-full font-bold  mb-16 ">
                                <div>暫無紀錄</div>
                            </div> : ""

                    }

                    <div className="flex w-full  mt-4 mb-2">
                        <div className="mx-auto">
                            <Pagination count={totalPage} page={page} onChange={handleChange} />
                        </div>
                    </div>
                </>
                : ""
        }
    </div>

}

export default Home